export default class SearchInput {
  constructor() {
    this.init();
  }

  init() {
    let inputs = document.querySelectorAll('.js-search-input');

    inputs.forEach((input) => {
      input.addEventListener('keyup', (e) => {
        let target = e.currentTarget;

        // Select input tooltip
        let searchInput = target.closest('.js-search-input-container');
        let tooltip = searchInput.querySelector('.js-search-input-tooltip');
        let characters = target.value.length;

        let countEl = document.querySelector('.js-search-input-count');

        // Update characters count number
        countEl.innerHTML = characters.toString();

        // Show input tooltip
        if (tooltip.classList.contains('scale-0')) {
          tooltip.classList.remove('scale-0');
          tooltip.classList.add('scale-100');
        }

        // Hide tooltip if the number of characters is zero
        if (characters == 0) {
          tooltip.classList.add('scale-0');
          tooltip.classList.remove('scale-100');
        }

        // Update progress bar
        let progressElements = searchInput.querySelector('.js-search-input-progress').getElementsByTagName('div');

        let index;

        switch (true) {
          // Success case
          case characters >= 6 && characters <= 14:
            index = 0;

            for (let item of progressElements) {
              item.classList.remove('is-success');
              item.classList.remove('is-warning');
              item.classList.remove('is-danger');
              item.classList.remove('is-empty');

              if (index <= 2) {
                item.classList.add('is-success');
              } else {
                item.classList.add('is-empty');
              }

              index++;
            }

            break;

          // Warning case
          case (characters >= 3 && characters < 6) || (characters > 14 && characters <= 24):
            index = 0;

            for (let item of progressElements) {
              item.classList.remove('is-success');
              item.classList.remove('is-warning');
              item.classList.remove('is-danger');
              item.classList.remove('is-empty');

              if (index <= 1) {
                item.classList.add('is-warning');
              } else {
                item.classList.add('is-empty');
              }

              index++;
            }

            break;

          // Error case
          case characters > 24 || characters < 3:
            index = 0;

            for (let item of progressElements) {
              item.classList.remove('is-success');
              item.classList.remove('is-warning');
              item.classList.remove('is-danger');
              item.classList.remove('is-empty');

              if (index == 0) {
                item.classList.add('is-danger');
              } else {
                item.classList.add('is-empty');
              }

              index++;
            }

            break;
        }
      });
    });
  }
}
